import { Strings } from "src/modules/utils/shared/strings";
import { Utils } from "src/modules/utils/shared/utils";
import { FrontendFieldType } from "./FrontendFieldType";
import { GenericDataType } from "src/modules/enaio/netgen/GenericDataType";

export enum TableCellType {
    //netgen start
    string = 0,
    int = 1,
    decimal = 2,
    bool = 3,
    date = 4,
    dateTime = 5,
    color = 6,
    button = 7,
    byteSize = 8,
    duration = 9,
    durationNanos = 10,
    link = 11,
    icon = 12,
    image = 13,
    object = 14
    //netgen end
}

export namespace TableCellType {
    export function convertValue(value: any, type: TableCellType): any {
        switch (type) {
            case TableCellType.int:
                return Utils.restrictDecimalDigits(Utils.toNumber(value), 0);
            case TableCellType.decimal:
                return Utils.toNumber(value);
            case TableCellType.bool:
                return Utils.toBool(value);
            case TableCellType.date:
                return Strings.is(value) ? new Date(value as string) : value;
            case TableCellType.dateTime:
                return Strings.is(value) ? new Date(value as string) : value;
            default:
                return value;
        }
    }

    export function toGenericDataType(type: TableCellType): GenericDataType {
        switch (type) {
            case TableCellType.string:
                return GenericDataType.string;
            case TableCellType.int:
            case TableCellType.byteSize:
            case TableCellType.duration:
            case TableCellType.durationNanos:
                return GenericDataType.int;
            case TableCellType.decimal:
                return GenericDataType.decimal;
            case TableCellType.bool:
                return GenericDataType.bool;
            case TableCellType.date:
                return GenericDataType.date;
            case TableCellType.dateTime:
                return GenericDataType.dateTime;
            default:
                return GenericDataType.object;
        }
    }

    export function toFrontendFieldType(type: TableCellType): FrontendFieldType {
        switch (type) {
            case TableCellType.string:
                return FrontendFieldType.string;
            case TableCellType.int:
            case TableCellType.byteSize:
            case TableCellType.duration:
            case TableCellType.durationNanos:
                return FrontendFieldType.int;
            case TableCellType.decimal:
                return FrontendFieldType.decimal;
            case TableCellType.bool:
                return FrontendFieldType.bool;
            case TableCellType.date:
                case TableCellType.dateTime:
                return FrontendFieldType.date;
            default:
                return FrontendFieldType.string;
        }
    }

}